import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import PageTitle from 'src/components/PageTitle';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import {
  Box,
  Button,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import DownloadIcon from '@mui/icons-material/Download';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { useParams } from 'react-router';
import dayjs, { Dayjs } from 'dayjs';
import { hasPermission } from 'src/components/Permissions/hasPermission';
import { get } from 'src/services/httpClient.service';

const Package_Channel_Reconciliation_Data = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(100);
  const { reconcileCode } = useParams();
  const [startDate, setStartDate] = useState<Dayjs | null>(dayjs());

  const columns = [
    { field: 'id', headerName: 'Sl. No', width: 90 },
    { field: 'packageId', headerName: 'Package Id', flex: 1, minWidth: 120 },
    { field: 'packageName', headerName: 'Package Name', flex: 1, minWidth: 150 },
    /* { field: 'packageType', headerName: 'Package Type', flex: 1, minWidth: 150 }, */
    // { field: 'package_code', headerName: 'Package Code', flex: 1, minWidth: 150 }, 
    { field: 'crmChannelCount', headerName: 'CRM Channel Count', flex: 1, minWidth: 150 },
    { field: 'drmChannelCount', headerName: 'DRM Channel Count', flex: 1, minWidth: 180 },
    { field: 'crmChannelData', headerName: 'CRM Channel Data', flex: 1, minWidth: 200 },
    { field: 'drmChannelData', headerName: 'DRM Channel Data', flex: 1, minWidth: 200 },
    { field: 'crmMissingData', headerName: 'Missing Data (In CRM but not in DRM)', flex: 1, minWidth: 200 },
    { field: 'drmMissingData', headerName: 'Missing Data (In DRM not in CRM)', flex: 1, minWidth: 200 },
    { field: 'crmStatus', headerName: 'CRM Status', flex: 1, minWidth: 200 },
    { field: 'drmStatus', headerName: 'DRM Status', flex: 1, minWidth: 200 },
    { field: 'createdDateStr', headerName: 'Added Date', flex: 1, minWidth: 150 },
    { field: 'createdBy', headerName: 'Added By', flex: 1, minWidth: 150 },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await get(`${process.env.REACT_APP_BASE_API_URL}/api/reconcile/pkg-channel-reconcile/${reconcileCode}`);
        const responseData = response['data']? response['data'] : [];
        const dataWithId = responseData.map((item: any, index: number) => ({
          id: index + 1,
          createdDateStr: dayjs(item.createdDate).format('DD-MM-YYYY HH:mm:ss'),
          ...item,
        }));
        setRows(dataWithId);
      } catch (error) {
        console.error('Error fetching DRM reconcile data:', error);
        setRows([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  //----- Exports
      const handleDownloadPDF = () => {
        const doc = new jsPDF();
        doc.setFontSize(12);
        doc.text('Manage_Package_Channel_Reconciliation_Data', 14, 15);
    
        const from = dayjs(startDate).format('YYYY-MM-DD');
       
        doc.setFontSize(10);
        doc.text(`${from}`, 14, 22);
    
        const tableColumn = columns.map((col) => col.headerName);
        const tableRows = rows.map((row) =>
          //columns.map((col) => row[col.field] || '')
          columns.map((col) => {
            let cellValue = row[col.field] ?? '';
  
            // if (col.field === 'crmChannelData' || col.field === 'drmChannelData') {
            //   // Ensure it's a string, then replace commas with pipes
            //   cellValue = String(cellValue)
            //   .replace(/^\[|\]$/g, '') // removes [ at start or ] at end
            //   //.replace(/,/g, '|') // replaces commas with pipes
            //   .trim();
            // }
  
            return cellValue;
          })
        );
    
        autoTable(doc, {
          head: [tableColumn],
          body: tableRows,
          startY: 30,
          styles: { fontSize: 8 },
          headStyles: { fillColor: [22, 160, 133] },
        });
    
        doc.save(`Manage_Package_Channel_Reconciliation_Data_${from}.pdf`);
      };
    
    const handleDownloadExcelReport = () => {
      try {
        const from = dayjs(startDate).format('YYYY-MM-DD');
        
    
        // Prepare header based on columns
        const headers = columns.map((col) => col.headerName);
    
        // Prepare data rows
        // const data = rows.map((row) =>
        //   columns.map((col) => row[col.field] ?? '')
        // );
        // Prepare data rows
        const data = rows.map((row) =>
          columns.map((col) => {
            let cellValue = row[col.field] ?? '';
  
            if (col.field === 'crmChannelData' || col.field === 'drmChannelData') {
              // Ensure it's a string, then replace commas with pipes
              cellValue = String(cellValue)
              .replace(/^\[|\]$/g, '') // removes [ at start or ] at end
              .replace(/,/g, '|') // replaces commas with pipes
              .trim();
            }
  
            return cellValue;
          })
        );
  
    
        const finalData = [headers, ...data];
    
        const worksheet = XLSX.utils.aoa_to_sheet(finalData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Pkg Channel Reconciliation');
    
        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });
    
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
    
        const fileName = `Pkg_Channel_Reconciliation_${from}.xlsx`;
        saveAs(blob, fileName);
      } catch (error) {
        console.error('Error generating Excel file:', error);
      }
    };
    //----- Exports

  return (
    <>
      <Helmet>
        <title>Manage Package Channel Reconciliation Data</title>
      </Helmet>

      <PageTitleWrapper>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Box>
          <PageTitle
            heading="Manage Package Channel Reconciliation Data"
            subHeading="Package Channel Reconciliation Data"
            handleClick={undefined}
          />
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
          { hasPermission(["OWNER"]) && (
            <Button variant="contained" color="primary" startIcon={<DownloadIcon />} onClick={handleDownloadExcelReport}>
              Download Excel
            </Button>
          )}
          { hasPermission(["OWNER"]) && (
            <Button variant="outlined" color="secondary" startIcon={<DownloadIcon />} onClick={handleDownloadPDF}>
              Download PDF
            </Button>
          )}
          </Box>
        </Box>
      </PageTitleWrapper>

      <Box sx={{ height: 'calc(100vh - 180px)', width: '100%', padding: '15px' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          loading={loading}
          pagination
          pageSize={pageSize}
          onPageSizeChange={(newSize) => setPageSize(newSize)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          getRowHeight={() => 'auto'}
          sx={{
            boxShadow: 'none',
            border: 2,
            borderColor: 'rgb(43 44 45)',
            '& .MuiDataGrid-cell': {
              alignItems: 'start',
              py: 1.5,
            },
          }}
        />
      </Box>
    </>
  );
};

export default Package_Channel_Reconciliation_Data;
